let errorPageHtmlElements: HTMLDivElement | null = null;
let errorPageCssLinkElement: HTMLLinkElement | null = null;

function addErrorPageCssLinkElement(): void {
  if (errorPageCssLinkElement) {
    return;
  }
  errorPageCssLinkElement = document.createElement('link');
  errorPageCssLinkElement.href = '/error-page.css';
  errorPageCssLinkElement.rel = 'stylesheet';
  document.head.appendChild(errorPageCssLinkElement);
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- process.env is typed as any
const isMobileBuild = process.env.isMobileDeviceBuild === 'true';
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- process.env is typed as any
const isDevBuild = process.env.isDevBuild === 'true';

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function isCacheMismatchError(error: Error): boolean {
  const message = error.message || '';
  // Detect single-spa loading errors caused by missing files (cache mismatch after deployment)
  return message.includes('LOADING_SOURCE_CODE');
}

const RELOAD_KEY = 'cache-mismatch-reload';

function canAutoReload(): boolean {
  return !sessionStorage.getItem(RELOAD_KEY);
}

function markReloadAttempt(): void {
  sessionStorage.setItem(RELOAD_KEY, 'true');
}

function addErrorPageHtmlElements(error?: Error): void {
  if (errorPageHtmlElements) {
    return;
  }
  const showErrorDetails = isDevBuild && error;

  errorPageHtmlElements = document.createElement('div');
  errorPageHtmlElements.id = 'error-page';
  errorPageHtmlElements.className = 'container';
  errorPageHtmlElements.innerHTML = `<div class="content">
        <img src="/something-went-wrong.svg">
        <div class="message">
        <h1>Something went wrong.</h1>
        ${isMobileBuild ? '<p>The app failed to load. Please try again.</p>' : ''}
        ${showErrorDetails ? `<p><strong>Error:</strong> <span>${escapeHtml(error.message)}</span></p>` : ''}
        </div>
        ${
          !isMobileBuild
            ? `<button class="button" type="button" onclick="window.location.reload();">
          <span class="button_text">Reload</span>
          <span class=""></span>
        </button>`
            : ''
        }
        ${showErrorDetails && error.stack ? `<pre class="details">${escapeHtml(error.stack)}</pre>` : ''}
      </div>`;
  document.body.appendChild(errorPageHtmlElements);
}

export function showErrorPage(error: Error): void {
  if (isCacheMismatchError(error) && !isMobileBuild && canAutoReload()) {
    markReloadAttempt();
    window.location.reload();
    return;
  }

  addErrorPageCssLinkElement();
  addErrorPageHtmlElements(error);
}
